import * as React from "react";

import { Icon } from "../../Icons/Icon";
import { AllIconNames } from "../../Internals/ControlsReexport/react-ui";
import { useCandyTheme } from "../../Internals/ThemeProvider/CandyTheme/UseCandyTheme";

import { ActionItemLink, ActionItemRoot } from "./ActionItem.styles";

export interface ActionItemProps {
    icon: AllIconNames | "";
    href?: string;
    text: string;
    onClick?: (event: React.SyntheticEvent) => void;
    children?: React.ReactNode;
    disabled?: boolean;
    download?: boolean;
    place: "panel" | "footer";
    id?: string;
}

export const ActionItem = React.forwardRef(function ActionItem(
    props: ActionItemProps,
    ref: React.ForwardedRef<HTMLDivElement & HTMLSpanElement & HTMLLIElement>
): JSX.Element {
    const theme = useCandyTheme();

    const { download, icon, place = "panel", text, disabled } = props;

    const handleOnClick = (event: React.SyntheticEvent) => {
        if (disabled) {
            return;
        }
        props.onClick?.(event);
    };

    return (
        <ActionItemRoot place={place} ref={ref}>
            <ActionItemLink
                data-tid={`SimpleForm-${props.id ?? props.text}`}
                rel="noreferrer"
                href={props.href}
                target={props.href != undefined ? "_blank" : undefined}
                place={place}
                disabled={disabled}
                download={download}
                onClick={handleOnClick}>
                {icon !== "" && (
                    <>
                        <Icon
                            name={icon}
                            size={
                                place === "footer"
                                    ? theme.typography.header4.fontSize.getNumber()
                                    : theme.typography.primary.fontSize.getNumber()
                            }
                        />{" "}
                    </>
                )}
                <span>{text}</span>
            </ActionItemLink>
            {props.children}
        </ActionItemRoot>
    );
});
ActionItem.displayName = "ActionItem";
